// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uJIIc{display:none}@media(max-width:1023px){.uJIIc{display:block;margin-bottom:1.5rem}}@media(max-width:1023px){._2rrqs{display:none}}._1NEEF{position:fixed;top:0;left:0;width:100%;height:100vh;padding:1.5rem 2rem;background-color:#f7f8f8;z-index:var(--zIndex-modal);overflow-y:auto}@media(max-width:767px){._1NEEF{padding-left:0;padding-right:0}}._1NEEF .PaERS{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;margin-bottom:1.5rem}@media(max-width:767px){._1NEEF .PaERS{padding-left:1rem;padding-right:1rem}}._1NEEF ._1cH6K{margin-left:auto}", ""]);
// Exports
exports.locals = {
	"toggler": "uJIIc",
	"wrapper": "_2rrqs",
	"modalWrapper": "_1NEEF",
	"header": "PaERS",
	"closeIcon": "_1cH6K"
};
module.exports = exports;
